import { Component, OnInit, Input } from '@angular/core';
import { DxDataGridModule, DxSelectBoxModule, DxTemplateModule } from 'devextreme-angular';
import {Router, ActivatedRoute} from '@angular/router';
import { Configuration } from '../../../app.constants';
import{ChecklistRegistrationInfoComponent} from '../Registration/checklist-registration-info.component';
import { SystemmenuService, SystemModule, ContactSuport } from '../../../shared/services/systemmenu.service';

@Component({
  selector: 'checklistcontact',
  templateUrl: './checklistcontact.component.html',
  styleUrls: ['./checklistcontact.component.scss']
})
export class ChecklistcontactComponent implements OnInit {

  @Input() index:any;
  @Input() isON:boolean;
  @Input() formname:string;

  LanguageLabel:any;
  disabledAgreement: boolean = true;
  
  @Input() htmlcontent:string;
  Inst:string
  ContactList:any;
  constructor(private router: Router,private Configuration:Configuration,
    public ChecklistRegistrationInfoComponent:ChecklistRegistrationInfoComponent,
    public systemMenuService:SystemmenuService) {

  }
  ngOnInit() {
    debugger;
    this.ContactList= this.systemMenuService.GetContactList();
    this.Configuration.loggedstatus="N";
    this.LanguageLabel =this.Configuration.LanguageLabel[0];
    this.Inst=this.htmlcontent;
  }
  onContentReady(e) {
    e.component.option("loadPanel.enabled", false);
  }
  customizeColumns(columns) {
    columns[0].width = 70;
  }
  cancelClick() {
    debugger;
    this.ChecklistRegistrationInfoComponent.popupVisibleInst=false;
  }
  

}


